// extracted by mini-css-extract-plugin
export var animationContainer = "_jt-0";
export var footer = "_jt-1";
export var gray = "_jt-2";
export var lineItem = "_jt-3";
export var lineItemImage = "_jt-4";
export var lineItemInfo = "_jt-5";
export var lineItemText = "_jt-6";
export var lineItems = "_jt-7";
export var modalContent = "_jt-8";
export var options = "_jt-9";
export var orderName = "_jt-a";
export var refundAmount = "_jt-b";